<template>
  <div class="alertHeader">
    <template>
      <v-card-title :data-cy="dataCy">
        <v-icon class="header-icon">{{ icon }}</v-icon>
        {{ $t(`map.deviceAlerts.${title}`) }}
      </v-card-title>
    </template>
      <v-form ref="form" v-if="title === 'editTitle' || title === 'addTitle'">
        <v-switch
          v-model="currentAlert.enabled"
          v-bind:label="$t('map.deviceAlerts.fields.enabled')"
          color="primary"
          data-cy="addEnabled"
          class="addEnabledElement"
        ></v-switch>
      </v-form>
  </div>
</template>

<script>
export default {
  props: {
    currentAlert: Object,
    title: String,
    icon: String,
    dataCy: String,
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
  .v-card__title {
    font-size: 24px;
    font-weight: 300;
    justify-content: flex-start;
    padding: 8px 0px 16px 16px;
    .header-icon {
      color: rgba(0, 0, 0, 0.76);
      margin-right: 16px;
    }
  }
  .v-btn {
    min-width: 120px !important;
    @media (min-width: 496px) {
      min-width: 160px !important;
    }
  }
  .alertHeader {
    display: flex;
    justify-content: space-between;
    margin: 0px;
    padding: 0px;
  }
  .addEnabledElement {
    padding: 0px 32px 0px 0px;
    align-content: center;
  }
</style>
